import { render, staticRenderFns } from "./SearchUserForm.vue?vue&type=template&id=60834c5c&scoped=true&"
import script from "./SearchUserForm.vue?vue&type=script&lang=js&"
export * from "./SearchUserForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchUserForm.vue?vue&type=style&index=0&id=60834c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60834c5c",
  null
  
)

export default component.exports